<section class="connect-paypal">
    <div class="loading">
        <app-loading> </app-loading>
    </div>
    <label>Connecting PayPal account...</label>
</section>
